<h2>Sólo documentos publicados el :</h2>
<mat-dialog-content>
  <p>{{ data.selected_date }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
